var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 295,
    height: 140,
    viewBox: "0 0 295 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: 116.217,
    y: 21.204,
    width: 106.43,
    height: 115.691,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40 -1051)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 140,
    transform: "translate(40 1051)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105.374 1051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.233,41.791V29.515h10.939V52.267Z",
    transform: "translate(12.205 3.021)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.41,42.418V31.7h8.157V52.044Z",
    transform: "translate(12.325 3.244)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.175,20.335a10.168,10.168,0,1,0-10.2-10.168A10.182,10.182,0,0,0,138.175,20.335Z",
    transform: "translate(13.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.985,18.113a8.134,8.134,0,1,0-8.157-8.134A8.146,8.146,0,0,0,137.985,18.113Z",
    transform: "translate(13.289 0.189)",
    fill: "#ff9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.049,54.782a15.911,15.911,0,0,0-3.3-23.829,9.41,9.41,0,0,0,1.513-5.13,9.115,9.115,0,0,0-17.9-2.61A13.559,13.559,0,0,0,32.7,16.5,13.753,13.753,0,0,0,19.084,30.391a14.1,14.1,0,0,0,.834,4.794c-.276-.022-.556-.043-.834-.043A11.047,11.047,0,0,0,8.146,46.289q0,.568.056,1.126A13.852,13.852,0,0,0,0,60.132,13.71,13.71,0,0,0,13.572,73.975a13.382,13.382,0,0,0,2.349-.211c-.041.46-.065.924-.065,1.4A15.38,15.38,0,0,0,31.086,90.693a14.953,14.953,0,0,0,8.672-2.773,11.2,11.2,0,0,0,7.363,2.773A11.492,11.492,0,0,0,58.5,79.088c0-.277-.022-.555-.041-.823H58.5A12.305,12.305,0,0,0,70.682,65.841a12.451,12.451,0,0,0-6.633-11.059Z",
    transform: "translate(0 1.689)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.088,54.5a14.934,14.934,0,0,0-3.1-22.369,8.826,8.826,0,0,0,1.42-4.807A8.557,8.557,0,0,0,43.6,24.869a12.726,12.726,0,0,0-10.938-6.3A12.911,12.911,0,0,0,19.885,31.608a13.24,13.24,0,0,0,.782,4.5c-.26-.02-.519-.041-.782-.041A10.357,10.357,0,0,0,9.624,46.534c0,.357.019.708.052,1.056a13,13,0,0,0-7.7,11.937,12.868,12.868,0,0,0,12.74,12.993,12.567,12.567,0,0,0,2.2-.2c-.037.433-.061.871-.061,1.313a14.439,14.439,0,0,0,14.3,14.579,14.035,14.035,0,0,0,8.14-2.588A10.508,10.508,0,0,0,46.2,88.212,10.789,10.789,0,0,0,56.88,77.32c0-.261-.02-.516-.039-.773h.039a11.713,11.713,0,0,0,9.775-17.724A11.709,11.709,0,0,0,62.088,54.5Z",
    transform: "translate(0.202 1.901)",
    fill: "#00897b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.355,36.068h-3.32v82.36h3.32Z",
    transform: "translate(3.382 3.692)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.562,37.117h-1.67v81.2h1.67Z",
    transform: "translate(3.469 3.799)",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.459,45.435,33.754,60.195l1.226,1.132L48.685,46.567Z",
    transform: "translate(3.455 4.651)",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.963,60.7l-1,1.337,14.21,10.524,1-1.337Z",
    transform: "translate(2.146 6.213)",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.729,62.507a12.833,12.833,0,0,1-3.5-8.785,13.036,13.036,0,0,1,6.416-11.149,7.565,7.565,0,0,1-1.331-4.283,7.948,7.948,0,0,1,8.092-7.8,8.053,8.053,0,0,1,7.764,5.613A12.151,12.151,0,0,1,67.5,30.493a11.837,11.837,0,0,1,12.05,11.619,11.218,11.218,0,0,1-.742,4.01c.245-.018.489-.035.742-.035a9.506,9.506,0,0,1,9.679,9.325,9.067,9.067,0,0,1-.05.941,11.582,11.582,0,0,1,7.269,10.639,11.8,11.8,0,0,1-12.02,11.58,12.53,12.53,0,0,1-2.08-.185c.035.386.057.775.057,1.17A13.247,13.247,0,0,1,68.916,92.551a13.775,13.775,0,0,1-7.669-2.315,10.257,10.257,0,0,1-6.522,2.315,9.9,9.9,0,0,1-10.076-9.707c0-.233.019-.46.035-.69h-.035a10.6,10.6,0,0,1-10.789-10.4A10.365,10.365,0,0,1,39.729,62.507Z",
    transform: "translate(3.466 3.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7,62.341a12.282,12.282,0,0,1-3.337-8.41A12.476,12.476,0,0,1,43.5,43.261a7.233,7.233,0,0,1-1.281-4.108,7.609,7.609,0,0,1,7.745-7.463A7.715,7.715,0,0,1,57.4,37.063,11.632,11.632,0,0,1,67.273,31.7a11.336,11.336,0,0,1,11.542,11.12,10.735,10.735,0,0,1-.706,3.84c.234-.017.467-.035.706-.035a9.1,9.1,0,0,1,9.269,8.925,8.707,8.707,0,0,1-.046.9A11.086,11.086,0,0,1,95,66.629,11.307,11.307,0,0,1,83.49,77.721a11.983,11.983,0,0,1-1.989-.177c.033.37.054.739.054,1.12A12.68,12.68,0,0,1,68.646,91.1,13.189,13.189,0,0,1,61.3,88.883,9.817,9.817,0,0,1,55.054,91.1a9.469,9.469,0,0,1-9.64-9.291c0-.222.019-.44.035-.66h-.035A10.144,10.144,0,0,1,35.086,71.2,9.891,9.891,0,0,1,40.7,62.341Z",
    transform: "translate(3.591 3.244)",
    fill: "#009688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.036,47.694H58.26V116.82h3.776Z",
    transform: "translate(5.964 4.882)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.169,47.694H59.082V116.82h2.087Z",
    transform: "translate(6.048 4.882)",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.805,54.392l-1.491,1.457L60.693,68.441l1.491-1.457Z",
    transform: "translate(4.946 5.568)",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.509,67.371l-12.832,8.98,1.2,1.7,12.832-8.98Z",
    transform: "translate(6.109 6.896)",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.761,58.7h-93.1c-2.126,0-3.849.954-3.849,2.133v68.157H149.616V60.829C149.616,59.649,147.887,58.7,145.761,58.7Z",
    transform: "translate(4.996 6.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -65.37, 0)",
    filter: "url(#\\u30D1\\u30B9_2198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.773,23.317,50.2,59.292v70.716h97.43V61.858Z",
    transform: "translate(70.51 2.39)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.355,64.54A10.785,10.785,0,1,0,84.54,53.755,10.8,10.8,0,0,0,95.355,64.54Z",
    transform: "translate(8.654 4.399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.732,71.622H58.613V90.687H77.732Z",
    transform: "translate(6 7.331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.514,71.622H112.4V90.687h19.118Z",
    transform: "translate(11.505 7.331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.947,77.893l-2.59-14.445L100.1,16.9l60.126,47.481-1.668,12.961L100.088,33.343Z",
    transform: "translate(4.029 1.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.98,74.845,40.2,64.864,100,18.333,159.21,64.868l-1.792,9.972L99.987,29.706Z",
    transform: "translate(4.115 1.877)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.033,91.187H83.665v31.873h23.368Z",
    transform: "translate(8.564 9.334)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.293,91.8H84.277V123h22.016Z",
    transform: "translate(8.627 9.397)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.169,72.232H59.4v6.26H77.169Z",
    transform: "translate(6.08 7.394)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.169,77.911H59.4V89.369H77.169Z",
    transform: "translate(6.08 7.975)",
    fill: "#0d71e8",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.777,72.232H113.01v6.26h17.767Z",
    transform: "translate(11.568 7.394)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.777,77.911H113.01V89.369h17.767Z",
    transform: "translate(11.568 7.975)",
    fill: "#0d71e8",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.178,62.489a9.829,9.829,0,0,0,9.849-9.831h-19.7a9.844,9.844,0,0,0,9.85,9.831Z",
    transform: "translate(8.734 5.39)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.178,62.4a9.836,9.836,0,0,0,9.849-9.822h-19.7a9.836,9.836,0,0,0,9.85,9.822Z",
    transform: "translate(8.734 5.382)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.178,43.757a9.836,9.836,0,0,0-9.85,9.813h19.7a9.836,9.836,0,0,0-9.849-9.813Z",
    transform: "translate(8.734 4.479)",
    fill: "#0d71e8",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.178,43.757a9.836,9.836,0,0,0-9.85,9.813h19.7a9.836,9.836,0,0,0-9.849-9.813Z",
    transform: "translate(8.734 4.479)",
    fill: "#0d71e8",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.821,108.388a2.311,2.311,0,1,0-2.317-2.311A2.313,2.313,0,0,0,99.821,108.388Z",
    transform: "translate(9.981 10.622)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.767,107.758a1.734,1.734,0,1,0-1.739-1.734A1.736,1.736,0,0,0,99.767,107.758Z",
    transform: "translate(10.034 10.675)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.425,115.995H81.037v9.243h28.388Z",
    transform: "translate(8.295 11.874)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.791,116.693H81.561v7.9h27.23Z",
    transform: "translate(8.349 11.945)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.673,98.3a7.335,7.335,0,0,0-1.52-10.983,4.334,4.334,0,0,0,.7-2.364,4.2,4.2,0,0,0-8.253-1.2,6.249,6.249,0,0,0-5.376-3.093,6.34,6.34,0,0,0-6.277,6.4,6.5,6.5,0,0,0,.384,2.218c-.128-.009-.254-.02-.384-.02A5.09,5.09,0,0,0,33.9,94.39a3.467,3.467,0,0,0,.026.52,6.386,6.386,0,0,0-3.784,5.862,6.319,6.319,0,0,0,6.257,6.38,6.254,6.254,0,0,0,1.083-.1c-.019.213-.03.427-.03.645a7.1,7.1,0,0,0,7.021,7.16,6.894,6.894,0,0,0,4-1.275,5.163,5.163,0,0,0,3.394,1.275,5.3,5.3,0,0,0,5.245-5.348c0-.128-.009-.254-.019-.379h.019a5.673,5.673,0,0,0,5.615-5.731,5.74,5.74,0,0,0-3.055-5.1Z",
    transform: "translate(3.086 8.256)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.767,98.165a6.884,6.884,0,0,0-1.427-10.31,4.068,4.068,0,0,0,.654-2.219,3.944,3.944,0,0,0-7.747-1.129,5.866,5.866,0,0,0-5.041-2.9,5.951,5.951,0,0,0-5.891,6.008,6.1,6.1,0,0,0,.361,2.074c-.119,0-.239-.019-.361-.019a4.777,4.777,0,0,0-4.729,4.823,3.244,3.244,0,0,0,.024.486,5.994,5.994,0,0,0-3.552,5.5,5.933,5.933,0,0,0,5.873,5.99,5.812,5.812,0,0,0,1.016-.09c-.017.2-.028.4-.028.6a6.655,6.655,0,0,0,6.589,6.72,6.471,6.471,0,0,0,3.752-1.2,4.845,4.845,0,0,0,3.187,1.2,4.971,4.971,0,0,0,4.922-5.021c0-.12-.009-.238-.019-.356h.019a5.324,5.324,0,0,0,5.272-5.376,5.387,5.387,0,0,0-2.874-4.785Z",
    transform: "translate(3.179 8.353)",
    fill: "#00897b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.907,89.671H45.376v37.965h1.531Z",
    transform: "translate(4.645 9.179)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.541,90.154h-.769v37.432h.769Z",
    transform: "translate(4.685 9.228)",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.027,93.982l-6.318,6.8.565.521,6.318-6.8Z",
    transform: "translate(4.679 9.62)",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.272,101.026l-.459.616,6.55,4.852.459-.616Z",
    transform: "translate(4.075 10.341)",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.464,101.859a5.906,5.906,0,0,1-1.611-4.05,6.009,6.009,0,0,1,2.966-5.139,3.483,3.483,0,0,1-.617-1.978,3.662,3.662,0,0,1,3.73-3.594,3.707,3.707,0,0,1,3.58,2.588A5.6,5.6,0,0,1,61.27,87.1a5.467,5.467,0,0,1,5.562,5.361,5.164,5.164,0,0,1-.341,1.849c.113,0,.226-.017.341-.017a4.383,4.383,0,0,1,4.462,4.3,4.2,4.2,0,0,1-.022.434,5.339,5.339,0,0,1,3.35,4.9,5.442,5.442,0,0,1-5.541,5.339,5.7,5.7,0,0,1-.958-.082c.017.185.026.357.026.54a6.105,6.105,0,0,1-6.218,5.989,6.35,6.35,0,0,1-3.541-1.066,4.734,4.734,0,0,1-3.009,1.059,4.562,4.562,0,0,1-4.644-4.476,2.016,2.016,0,0,1,.017-.319h-.017a4.886,4.886,0,0,1-4.974-4.792,4.775,4.775,0,0,1,2.7-4.263Z",
    transform: "translate(4.684 8.915)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.911,101.783A5.662,5.662,0,0,1,47.368,97.9,5.751,5.751,0,0,1,50.2,92.981a3.334,3.334,0,0,1-.591-1.893,3.507,3.507,0,0,1,3.571-3.44A3.555,3.555,0,0,1,56.6,90.123a5.361,5.361,0,0,1,4.555-2.475,5.226,5.226,0,0,1,5.321,5.126,4.95,4.95,0,0,1-.326,1.769c.108,0,.215-.017.326-.017a4.194,4.194,0,0,1,4.264,4.115,4.033,4.033,0,0,1-.022.416,5.11,5.11,0,0,1,3.207,4.694,5.21,5.21,0,0,1-5.3,5.109,5.556,5.556,0,0,1-.927-.077c.017.17.026.342.026.515a5.843,5.843,0,0,1-5.951,5.731,6.075,6.075,0,0,1-3.389-1.021,4.521,4.521,0,0,1-2.877,1.021,4.37,4.37,0,0,1-4.449-4.283,1.82,1.82,0,0,1,.017-.3h-.017a4.677,4.677,0,0,1-4.761-4.587,4.567,4.567,0,0,1,2.614-4.074Z",
    transform: "translate(4.739 8.972)",
    fill: "#009688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.744,95.029H57v31.863h1.741Z",
    transform: "translate(5.835 9.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.345,95.029h-.962v31.863h.962Z",
    transform: "translate(5.874 9.727)",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.106,98.118l-.687.672,5.706,5.8.687-.671Z",
    transform: "translate(5.366 10.044)",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.573,104.1l-5.915,4.139.553.786,5.915-4.139Z",
    transform: "translate(5.902 10.656)",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,84.481,27.529,97.462,41.7,84.481",
    transform: "translate(1.536 8.648)",
    fill: "none",
    stroke: "#37474f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2,78.518h-8.4v51.763h8.4Z",
    transform: "translate(0.388 8.037)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.476,79.411H4.391v48.97h7.085Z",
    transform: "translate(0.449 8.129)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.275,80.456H1.85v9.038H52.275Z",
    transform: "translate(0.189 8.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.448,81.35v7.066H51.555V81.35Z",
    transform: "translate(0.251 8.327)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.818,86.1a1.479,1.479,0,1,0-1.483-1.479A1.481,1.481,0,0,0,7.818,86.1Z",
    transform: "translate(0.648 8.51)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.843,86.1a1.479,1.479,0,1,0-1.483-1.479A1.481,1.481,0,0,0,43.843,86.1Z",
    transform: "translate(4.336 8.51)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.788,85.738a1.15,1.15,0,1,0-1.153-1.15A1.151,1.151,0,0,0,7.788,85.738Z",
    transform: "translate(0.679 8.541)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.813,85.738a1.15,1.15,0,1,0-1.153-1.15A1.151,1.151,0,0,0,43.813,85.738Z",
    transform: "translate(4.367 8.541)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.567,95.511h-31.8v21.526h31.8Z",
    transform: "translate(1.306 9.777)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3,95.735H12.985v20.705H44.3Z",
    transform: "translate(1.329 9.8)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.357,98.716H16.275v1.973H38.357Z",
    transform: "translate(1.666 10.105)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.592,102.219H19.938v1.972H35.592Z",
    transform: "translate(2.041 10.463)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.094,105.722H18.144v1.972h18.95Z",
    transform: "translate(1.857 10.822)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.58,109.225H16.5V111.2H38.58Z",
    transform: "translate(1.689 11.181)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.988,103.531a6.668,6.668,0,0,1,1.382-9.983,3.948,3.948,0,0,1-.634-2.15,3.82,3.82,0,0,1,7.5-1.094,5.68,5.68,0,0,1,4.887-2.812,5.764,5.764,0,0,1,5.706,5.82,5.918,5.918,0,0,1-.348,2.009c.115,0,.232-.018.348-.018a4.625,4.625,0,0,1,4.58,4.672,3.193,3.193,0,0,1-.023.471,5.806,5.806,0,0,1,3.44,5.33,5.746,5.746,0,0,1-5.688,5.8,5.569,5.569,0,0,1-.984-.088c.018.185.029.388.029.585a6.446,6.446,0,0,1-6.384,6.509,6.265,6.265,0,0,1-3.634-1.159,4.691,4.691,0,0,1-3.089,1.159,4.817,4.817,0,0,1-4.768-4.864,2.413,2.413,0,0,1,.017-.346h-.017a5.226,5.226,0,0,1-4.363-7.911A5.227,5.227,0,0,1,123.988,103.531Z",
    transform: "translate(12.407 8.955)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.641,103.412a6.258,6.258,0,0,1,1.3-9.373,3.69,3.69,0,0,1-.594-2.017,3.586,3.586,0,0,1,7.044-1.028,5.333,5.333,0,0,1,4.587-2.64,5.4,5.4,0,0,1,5.355,5.463A5.528,5.528,0,0,1,142,95.7c.11,0,.217-.017.329-.017a4.343,4.343,0,0,1,4.3,4.385,2.93,2.93,0,0,1-.022.442,5.45,5.45,0,0,1,3.229,5,5.39,5.39,0,0,1-5.339,5.443,5.233,5.233,0,0,1-.927-.083c.017.185.026.369.026.554a6.053,6.053,0,0,1-5.992,6.11,5.888,5.888,0,0,1-3.411-1.089,4.4,4.4,0,0,1-2.9,1.089,4.519,4.519,0,0,1-4.474-4.565,2.1,2.1,0,0,1,.017-.323h-.017a4.841,4.841,0,0,1-4.793-4.888,4.9,4.9,0,0,1,2.61-4.354Z",
    transform: "translate(12.491 9.044)",
    fill: "#00897b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.364,95.688h-1.392v34.517h1.392Z",
    transform: "translate(13.611 9.795)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.941,96.128h-.7V130.16h.7Z",
    transform: "translate(13.639 9.84)",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.772,99.628l-.514.475L134,106.288l.515-.475Z",
    transform: "translate(13.129 10.198)",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.468,106.006l-5.956,4.412.418.561,5.956-4.412Z",
    transform: "translate(13.667 10.851)",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.863,106.77a5.376,5.376,0,0,0,1.465-3.683,5.463,5.463,0,0,0-2.689-4.679,3.167,3.167,0,0,0,.557-1.8,3.332,3.332,0,0,0-3.391-3.269,3.376,3.376,0,0,0-3.254,2.352,5.091,5.091,0,0,0-4.327-2.352,4.963,4.963,0,0,0-5.053,4.869,4.708,4.708,0,0,0,.31,1.68c-.1,0-.206-.015-.31-.015a3.985,3.985,0,0,0-4.057,3.908,3.9,3.9,0,0,0,.021.394,4.856,4.856,0,0,0-3.046,4.459,4.948,4.948,0,0,0,5.037,4.853,5.122,5.122,0,0,0,.871-.074c-.014.161-.023.326-.023.491a5.552,5.552,0,0,0,5.652,5.446,5.775,5.775,0,0,0,3.219-.97,4.292,4.292,0,0,0,2.742.981,4.148,4.148,0,0,0,4.223-4.067,1.846,1.846,0,0,0-.015-.289h.015a4.442,4.442,0,0,0,4.522-4.357,4.338,4.338,0,0,0-2.468-3.88Z",
    transform: "translate(11.269 9.555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.353,106.7a5.148,5.148,0,0,0,1.409-3.525,5.228,5.228,0,0,0-2.573-4.472,3.03,3.03,0,0,0,.537-1.721,3.189,3.189,0,0,0-3.245-3.128,3.231,3.231,0,0,0-3.115,2.252,4.875,4.875,0,0,0-4.142-2.252,4.751,4.751,0,0,0-4.836,4.66,4.507,4.507,0,0,0,.3,1.608c-.1,0-.2-.015-.3-.015a3.813,3.813,0,0,0-3.883,3.74c0,.123.008.247.021.369a4.646,4.646,0,0,0-2.917,4.267,4.736,4.736,0,0,0,4.821,4.645,4.929,4.929,0,0,0,.834-.071c-.015.155-.023.311-.023.47a5.315,5.315,0,0,0,5.41,5.213,5.529,5.529,0,0,0,3.081-.924,4.106,4.106,0,0,0,2.616.924,3.974,3.974,0,0,0,4.041-3.892,1.637,1.637,0,0,0-.015-.276h.015a4.254,4.254,0,0,0,4.329-4.171,4.156,4.156,0,0,0-2.366-3.7Z",
    transform: "translate(11.322 9.607)",
    fill: "#009688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.812,100.562h-1.583v28.97h1.583Z",
    transform: "translate(12.512 10.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.4,100.562h-.875v28.97h.875Z",
    transform: "translate(12.542 10.294)",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.745,103.37l-5.187,5.276.624.611,5.188-5.276Z",
    transform: "translate(12.545 10.581)",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.238,108.811l-.5.714,5.378,3.763.5-.713Z",
    transform: "translate(12.052 11.138)",
    fill: "#795548"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.d1ca6488e3d7fe768dae014e5670225d.svg";
export { ForwardRef as ReactComponent };